module.exports = __webpack_public_path__ + "static/media/wizardRedEyes.fdf7aae5.gif";